import React from "react";
import { OrbitComponent } from "../../base-components/orbit-component/orbit-component";
import { Button } from "../../../basic-ui-components/button/base/button.component";

const ONBOARDING_TOUR_ALREADY_SHOWN = "onboarding_tour_already_shown";

export class OnboardingTourShowcase extends OrbitComponent {

    private openOnboarding = () => {
        this.services.onboardingTour.open();
    }

    render() {
        let onboardingAlreadyShown = this.services.localStorage.getItem(ONBOARDING_TOUR_ALREADY_SHOWN);
        if (onboardingAlreadyShown) {
            return <div>
                Onboarding tour was already presented to this user;
                <Button preset="info" onClick={() => {
                    this.services.localStorage.removeItem(ONBOARDING_TOUR_ALREADY_SHOWN);
                    window.location.reload();
                }}>Reset</Button>
            </div>;
        }

        return <div>
            <Button preset="primary" onClick={this.openOnboarding}>Start onboarding</Button>
        </div>
    }
}